import { BannerItem } from "@/types/banner";

export const defaultBannerContent: BannerItem[] = [
  {
    id: "1",
    text: "Now accepting new patients!",
    linkText: "Book an appointment",
    linkUrl: "/contact",
    sortOrder: 1,
  },
  {
    id: "2",
    text: "Check out our latest blog post on preventive care.",
    linkText: "Read more",
    linkUrl: "/resources",
    sortOrder: 2,
  },
  {
    id: "3",
    text: "We've expanded our services - learn about our new offerings.",
    linkText: "View services",
    linkUrl: "/services/all",
    sortOrder: 3,
  },
];
